import { c as _c } from "react/compiler-runtime";
import { BsBuilding, BsHeart, BsHouse, BsPeople } from 'react-icons/bs';
import type { FacilityType } from '@/app/_lib/parseFacilities';
interface FacilityIconProps {
  type: FacilityType;
  className?: string;
  variant?: 'filled' | 'outline';
}
export function getFacilityTypeColor(type: FacilityType): string {
  switch (type) {
    case 'corporate':
      return 'text-indigo-800 dark:text-indigo-400';
    case 'adult-residential':
      return 'text-teal-500 dark:text-teal-400';
    case 'elderly-residential':
      return 'text-amber-400 dark:text-amber-300';
    default:
      return 'text-gray-600 dark:text-gray-400';
  }
}
export function getFacilityTypeBgColor(type: FacilityType): string {
  switch (type) {
    case 'corporate':
      return 'bg-indigo-50 dark:bg-indigo-900/20';
    case 'adult-residential':
      return 'bg-teal-50 dark:bg-teal-900/20';
    case 'elderly-residential':
      return 'bg-amber-50 dark:bg-amber-900/20';
    default:
      return 'bg-gray-50 dark:bg-gray-900/20';
  }
}
export function FacilityIcon(t0) {
  const $ = _c(16);
  const {
    type,
    className: t1,
    variant: t2
  } = t0;
  const className = t1 === undefined ? "w-6 h-6" : t1;
  const variant = t2 === undefined ? "filled" : t2;
  const colorClass = getFacilityTypeColor(type);
  const combinedClassName = className.includes("text-") ? className : `${className} ${colorClass}`;
  const fillClass = variant === "filled" ? "fill-current" : "";
  if (variant === "outline") {
    switch (type) {
      case "corporate":
        {
          const t3 = `${combinedClassName} ${fillClass}`;
          let t4;
          if ($[0] !== t3) {
            t4 = <BsBuilding className={t3} />;
            $[0] = t3;
            $[1] = t4;
          } else {
            t4 = $[1];
          }
          return t4;
        }
      case "adult-residential":
        {
          const t3 = `${combinedClassName} ${fillClass}`;
          let t4;
          if ($[2] !== t3) {
            t4 = <BsPeople className={t3} />;
            $[2] = t3;
            $[3] = t4;
          } else {
            t4 = $[3];
          }
          return t4;
        }
      case "elderly-residential":
        {
          const t3 = `${combinedClassName} ${fillClass}`;
          let t4;
          if ($[4] !== t3) {
            t4 = <BsHeart className={t3} />;
            $[4] = t3;
            $[5] = t4;
          } else {
            t4 = $[5];
          }
          return t4;
        }
      default:
        {
          const t3 = `${combinedClassName} ${fillClass}`;
          let t4;
          if ($[6] !== t3) {
            t4 = <BsHouse className={t3} />;
            $[6] = t3;
            $[7] = t4;
          } else {
            t4 = $[7];
          }
          return t4;
        }
    }
  }
  switch (type) {
    case "corporate":
      {
        const t3 = `${combinedClassName} ${fillClass}`;
        let t4;
        if ($[8] !== t3) {
          t4 = <div className="relative"><BsBuilding className={t3} /></div>;
          $[8] = t3;
          $[9] = t4;
        } else {
          t4 = $[9];
        }
        return t4;
      }
    case "adult-residential":
      {
        const t3 = `${combinedClassName} ${fillClass}`;
        let t4;
        if ($[10] !== t3) {
          t4 = <div className="relative"><BsPeople className={t3} /></div>;
          $[10] = t3;
          $[11] = t4;
        } else {
          t4 = $[11];
        }
        return t4;
      }
    case "elderly-residential":
      {
        const t3 = `${combinedClassName} ${fillClass}`;
        let t4;
        if ($[12] !== t3) {
          t4 = <div className="relative"><BsHeart className={t3} /></div>;
          $[12] = t3;
          $[13] = t4;
        } else {
          t4 = $[13];
        }
        return t4;
      }
    default:
      {
        const t3 = `${combinedClassName} ${fillClass}`;
        let t4;
        if ($[14] !== t3) {
          t4 = <div className="relative"><BsHouse className={t3} /></div>;
          $[14] = t3;
          $[15] = t4;
        } else {
          t4 = $[15];
        }
        return t4;
      }
  }
}
export function getFacilityTypeLabel(type: FacilityType): string {
  switch (type) {
    case 'corporate':
      return 'Corporate Office';
    case 'adult-residential':
      return 'Adult Residential Facilities';
    case 'elderly-residential':
      return 'Residential Care Facilities for the Elderly';
    default:
      return 'Residential Facility';
  }
}
export function getFacilityTypeDescription(type: FacilityType): string {
  switch (type) {
    case 'corporate':
      return 'Our main training facility and corporate headquarters';
    case 'adult-residential':
      return 'Specialized residential care for adults with mental illness';
    case 'elderly-residential':
      return 'Residential care facilities dedicated to elderly residents';
    default:
      return 'Residential care facility';
  }
}